module.exports = __webpack_public_path__ + "img/pt-6.f0cca6b5.jpg";